import { IsoLocale } from './iso-locale.js';
import { getSupportEmail } from './support-emails.js';

let SupportLevel;
(function (SupportLevel) {
  SupportLevel["Standard"] = "standard";
  SupportLevel["GoPlus"] = "go-plus";
  SupportLevel["Pro"] = "pro";
})(SupportLevel || (SupportLevel = {}));
const SupportContacts = new Map([[IsoLocale.svSE, {
  email: getSupportEmail(IsoLocale.svSE),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+46108887267", "010 888 72 67"]], [SupportLevel.GoPlus, ["+46108887385", "010 888 73 85"]], [SupportLevel.Pro, ["+46105517689", "010 551 76 89"]]])
}], [IsoLocale.nbNO, {
  email: getSupportEmail(IsoLocale.nbNO),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+4721937202", "21 93 72 02"]], [SupportLevel.GoPlus, ["+4721958143", "21 958 143"]], [SupportLevel.Pro, ["+4721958143", "21 958 143"]]])
}], [IsoLocale.daDK, {
  email: getSupportEmail(IsoLocale.daDK),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+4589887870", "89 88 78 70"]], [SupportLevel.GoPlus, ["+4589886790", "89 88 67 90"]], [SupportLevel.Pro, ["+4589886790", "89 88 67 90"]]])
}], [IsoLocale.fiFI, {
  email: getSupportEmail(IsoLocale.fiFI),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+358753267785", "075 326 7786"]], [SupportLevel.GoPlus, ["+358753267786", "075 326 7786"]], [SupportLevel.Pro, ["+358753267786", "075 326 7786"]]])
}], [IsoLocale.svFI, {
  email: getSupportEmail(IsoLocale.svFI),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+358753267785", "075 326 7786"]], [SupportLevel.GoPlus, ["+358753267786", "075 326 7786"]], [SupportLevel.Pro, ["+358753267786", "075 326 7786"]]])
}], [IsoLocale.enGB, {
  email: getSupportEmail(IsoLocale.enGB),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+442039848464", "020 3984 8464"]], [SupportLevel.GoPlus, ["+442039848440", "020 3984 8440"]], [SupportLevel.Pro, ["+442039848440", "020 3984 8440"]]])
}], [IsoLocale.deDE, {
  email: getSupportEmail(IsoLocale.deDE),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+4915735991237", "015 735 991 237"]], [SupportLevel.GoPlus, ["+4915735991237", "015 735 991 237"]], [SupportLevel.Pro, ["+4915735991237", "015 735 991 237"]]])
}], [IsoLocale.frFR, {
  email: getSupportEmail(IsoLocale.frFR),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+33971070703", "09 71 07 07 03"]]])
}], [IsoLocale.nlNL, {
  email: getSupportEmail(IsoLocale.nlNL),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+31202251221", "020 225 1221"]]])
}], [IsoLocale.esES, {
  email: getSupportEmail(IsoLocale.esES),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+34917693585", "91 769 35 85"]]])
}], [IsoLocale.itIT, {
  email: getSupportEmail(IsoLocale.itIT),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+39645236990", "06 4523 6990"]]])
}], [IsoLocale.esMX, {
  email: getSupportEmail(IsoLocale.esMX),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+525553511412", "+52 55 5351 1412"]], [SupportLevel.Pro, ["+525553511412", "+52 55 5351 1412"]]])
}], [IsoLocale.ptBR, {
  email: getSupportEmail(IsoLocale.ptBR),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+558008924979", "0800-892-4979"]]])
}], [IsoLocale.enUS, {
  email: getSupportEmail(IsoLocale.enUS),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+18447211255", "844-721-1255"]]])
}], [IsoLocale.esUS, {
  email: getSupportEmail(IsoLocale.esUS),
  phoneNumbers: new Map([[SupportLevel.Standard, ["+18447211255", "844-721-1255"]]])
}]]);
const mapToObject = map => Array.from(map).reduce((acc, _ref) => {
  let [key, value] = _ref;
  return {
    ...acc,
    [key]: value
  };
}, {});
const supportContactsToJson = () => Array.from(SupportContacts).reduce((acc, _ref2) => {
  let [isoLocale, contactDetails] = _ref2;
  return {
    ...acc,
    [isoLocale]: {
      email: contactDetails.email,
      phoneNumbers: mapToObject(contactDetails.phoneNumbers)
    }
  };
}, {});

export { SupportContacts, SupportLevel, mapToObject, supportContactsToJson };
//# sourceMappingURL=support-contacts.js.map
